var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-taverns-page"},[_c('mobile-nav-bar',{attrs:{"text":"Taverns","fixed":"","scroll":"","scrollDefaultTheme":"scroll-hidden","scrollMark":220}}),_vm._v(" "),_c('mobile-taverns-page',{ref:"market",on:{"path":_vm.pathChange,"openDetail":_vm.openDetail}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41af901d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/_mobile/taverns.vue
// module id = null
// module chunks = 